import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10076478")

_pushScopeId("data-v-10076478")
const _hoisted_1 = { class: "white-back-mask" }
const _hoisted_2 = { class: "account-delete-notice-module" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "title" }, "账号注销后，将视为放弃以下权益，请确认知悉！", -1)
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "group_btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccountManageHeader = _resolveComponent("AccountManageHeader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_AccountManageHeader, { onClose: _ctx.closeModal }, null, 8, ["onClose"]),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.NOTICE_LIST, (item, index) => {
            return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", {
          class: "link",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLink && _ctx.openLink(...args)))
        }, "账号注销须知"),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            class: "btn close-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, "取消"),
          _createVNode("div", {
            class: "btn confirm-btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
          }, "确定注销")
        ])
      ])
    ])
  ]))
})